// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3718) return "static/chunks/3718.f944b3d5df1ee59f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"77":"b1051a5b81147efa","3491":"803d15fd94b6a9ed"}[chunkId] + ".js";
};